import styled from 'styled-components';

const HomeWrapper = styled.div`
  height: 100vh;
  background-color: #282c34;
  color: white;
`;

export { HomeWrapper };
